var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.8957C0 4.87817 4.87817 0 10.8957 0H23.9536C29.9711 0 34.8493 4.87817 34.8493 10.8957V23.9536C34.8493 29.9711 29.9711 34.8493 23.9536 34.8493H10.8957C4.87817 34.8493 0 29.9711 0 23.9536V10.8957Z",
    fill: "#E7000B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6779 18.3326C24.6779 22.8717 21.5005 25.1412 17.7239 26.4576C17.5262 26.5246 17.3113 26.5214 17.1157 26.4485C13.33 25.1412 10.1526 22.8717 10.1526 18.3326V11.9778C10.1526 11.737 10.2483 11.5061 10.4185 11.3358C10.5888 11.1656 10.8197 11.07 11.0605 11.07C12.8761 11.07 15.1457 9.98056 16.7253 8.60067C16.9176 8.43635 17.1623 8.34607 17.4153 8.34607C17.6682 8.34607 17.9129 8.43635 18.1052 8.60067C19.6939 9.98964 21.9544 11.07 23.77 11.07C24.0108 11.07 24.2417 11.1656 24.412 11.3358C24.5822 11.5061 24.6779 11.737 24.6779 11.9778V18.3326Z",
    stroke: "white",
    strokeWidth: 1.81565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogo);
export default __webpack_public_path__ + "static/media/ic_logo.e8c6cc39dd404e80dd4a657211ac98c0.svg";
export { ForwardRef as ReactComponent };